import PointMarker from "public/openStack/whiteMark.png";

export const WHY_ONEMIND_CONSTANTS = [
  {
    image: PointMarker,
    title: "Deep Virtualization & Cloud Expertise ",
    text: "Certified across VMware, Nutanix, OpenStack, and Zadara’s platform—plus decades of migration experience. ",
  },
  {
    image: PointMarker,
    title: "Automation-First",
    text: "Accelerate every phase using our Xmost Migrator and Zadara’s open APIs.",
  },
  {
    image: PointMarker,
    title: "Business Benefits",
    text: "• Slash CapEx/OpEx with Zadara’s consumption-based model\n• Eliminate vendor lock-in with fully open, interoperable infrastructure\n• Ensure data sovereignty and compliance with localized Zadara zones\n• Native Kubernetes, GPU acceleration, and storage tiering for modernization",
  },
];
